// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterBar-cls1_vPD","cls2":"FilterBar-cls2_5oq FilterBar-cls1_vPD"};